<div class="members-page">
  <form [formGroup]="form" (ngSubmit)="addMember()">
    <div class="addemail">
      <div class="input-wrapper email-wrapper">
        <label>Email Addresses</label>
        <input
          class="input"
          clearInput
          #email
          type="text"
          inputmode="email"
          formControlName="email"
          placeholder="Type or paste email addresses"
          (paste)="onEmailPaste($event)"
          (blur)="form.get('email').setValue(normalizeEmailList(form.get('email').value))"
          />
        <span class="email-hint">Separate addresses with semicolons, commas, spaces, or new lines.</span>
      </div>
      @if (topupEnabled && isSuperAdmin) {
        <app-disabled-feature-upsell
          class="allowance-disabled-upsell"
          title="Per-member monthly allowance is disabled"
          description="This control is visible for super admins, but updates are currently disabled."
          pillMode="relative"
          pillPosition="inline"
          >
          <div class="input-wrapper allowance-wrapper allowance-wrapper-disabled">
            <label>Monthly Allowance ($)</label>
            <input
              class="input"
              clearInput
              #allowance
              type="text"
              formControlName="allowance"
              (keypress)="validateNumber($event)"
              (paste)="validatePaste($event)"
              (blur)="formatCurrency()"
              [placeholder]="(currentWellspace.amount || 0) | currency"
              />
          </div>
        </app-disabled-feature-upsell>
      }
      <button
        mat-raised-button
        color="primary"
        [disabled]="!form.valid || uploading"
        class="addbutton"
        type="submit"
        >
        Add
      </button>
    </div>
  </form>

  <mat-divider></mat-divider>

  <div class="upload-section">
    <div class="upload-copy">
      <span class="info">
        Upload a CSV or XLSX file with a header row. Supported column headers are
        @for (column of teamMemberUploadColumns; track column; let last = $last) {
          <strong>{{ column }}</strong
            >@if (!last) {
            <span>, </span>
          }
          }.
          @for (column of requiredUploadColumns; track column; let last = $last) {
            <strong>{{ column }}</strong
              >@if (!last) {
              <span>, </span>
            }
          }
          {{ requiredUploadColumnVerb }} required. The other supported columns are
          optional and may appear in any order.
        </span>
        <span class="info">
          Use this template to format your member upload.
          <a download="Wallit-team-members-upload-template.csv" target="_blank" [href]="uploadTemplateUrl">
            Download template
          </a>
        </span>
      </div>
      <app-fileupload
        class="uploadarea"
        requiredFileType=".csv,.xlsx"
        (doneEvent)="uploadMembers($event)"
      ></app-fileupload>
      @if (result && result.newCount === 0 && result.invalidEmail?.length > 0 && result.alreadyMember?.length === 0) {
        <div
          class="error infosection"
          >
          <span class="infosection">Invalid File Format</span>
          <span
            ><br /><br />Upload a CSV or XLSX file with a header row. Supported column headers are
            {{ teamMemberUploadColumnList }}. {{ requiredUploadColumnList }} {{ requiredUploadColumnVerb }} required.</span
            >
          </div>
        }
        @if (result && result.invalidEmail && (result.alreadyMember?.length > 0 || result.newCount > 0)) {
          <div
            class="section"
            >
            <span class="infosection">Invalid Email Address</span>
            @for (info of result.invalidEmail; track info) {
              <span>Line {{info.line}}: {{info.email}}</span>
            }
          </div>
        }
        @if (result && result.alreadyMember?.length > 0) {
          <div class="section">
            <span class="infosection">Already a Member</span>
            @for (info of result.alreadyMember; track info) {
              <span>Line {{info.line}}: {{info.email}}</span>
            }
          </div>
        }
        @if (result && result.errorDetails?.length > 0) {
          <div class="section error upload-error-box">
            <span class="infosection">{{ result.errorMessage || 'Upload Error' }}</span>
            @for (info of getConsolidatedUploadErrorDetails(); track info.lineNumber + '::' + info.type) {
              <span>
                Line {{ info.lineNumber }}: {{ info.type }}@if (info.info) {
                <span>: {{ info.info }}</span>
              }
            </span>
          }
        </div>
      }
    </div>

    <div class="members-list-shell">
      <mat-divider></mat-divider>
      <div class="list">
        <div class="list-toolbar">
          <mat-button-toggle-group
            class="member-view-toggle"
            [(value)]="memberView"
            aria-label="Member status"
            >
            <mat-button-toggle value="current">Current ({{ members.length }})</mat-button-toggle>
            <mat-button-toggle value="removed">Removed ({{ removedMembers.length }})</mat-button-toggle>
          </mat-button-toggle-group>
          <div class="buttons">
            <button
              class="exportbutton"
              mat-raised-button
              color="accent"
              [disabled]="!currentWellspace.name"
              (click)="exportCsv(currentWellspace.name)"
              >
              <mat-icon>file_download</mat-icon>Export to CSV
            </button>
            <!--
            <button class="exportbutton" mat-raised-button color="accent" (click)="exportCensus()"><mat-icon>file_download</mat-icon>Export Census</button>
            -->
            <app-send-invites-button
              [teamId]="getTeamId()"
              [pendingInvitesCount]="pendingInvitesCount"
              [hasPendingAutomation]="hasPendingInviteAutomation"
              (invitesSent)="loadTeamMembers()"
            ></app-send-invites-button>
          </div>
        </div>
        @if (memberView === 'removed' && removedMembers.length === 0 && !isLoadingMembers) {
          <app-inlinemessage
            class="no-removed-members"
            level="info"
            message="There are no removed members in this workspace"
          ></app-inlinemessage>
        }
        @for (member of visibleMembers; track member) {
          <div class="card">
            <app-user-item
              (memberChangedEvent)="loadTeamMembers()"
              class="useritem"
              [showHeader]="member === visibleMembers[0]"
              [team]="currentWellspace"
              [wallitBalance]="isAdmin"
              [member]="member"
              [detail]="true"
              [readOnly]="memberView === 'removed'"
              [allowRestore]="memberView === 'removed'"
            ></app-user-item>
          </div>
        }
      </div>
    </div>
  </div>
